// extracted by css-extract-rspack-plugin
export default {"cls1":"HeroThumbnailStack-cls1_anH","cls2":"HeroThumbnailStack-cls2_lID HeroThumbnailStack-cls1_anH"};